module.exports = __webpack_public_path__ + "img/fullscreen.9ce971c6.svg";